
import React, { useEffect } from 'react';
import { setTitle } from '../../shared/services/general/general-service';
import Footer from '../../components/footer/footer';

export default function ContactUsContent () {

	return (<>
		<div className="text-center">
			<p>در صورت داشتن مشکل می توانید از طریق ایمیل زیر با ما در ارتباط باشید:
				<br />
				<br />
				info@bebin.com
				<br /><br />
				ساعت پاسخ به ایمیل ها شنبه تا چهارشنبه از ساعت 9 الی 18</p>
		</div>
	</>);
}
